// src/icons/StackedLines.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function StackedLines({
  strokeWidth = "1.5",
  strokeLinecap = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      viewBox: "0 0 20 16",
      width: "100%",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.5466 1.55566H1.1864M18.5466 8.00009H1.1864M18.5466 14.4445H1.1864",
          stroke: "currentColor",
          strokeWidth,
          strokeLinecap
        }
      )
    }
  );
}

export {
  StackedLines
};
